module.exports = __webpack_public_path__ + "img/diamonds-without@2x.9fbd553.jpg";